import React, { memo } from "react";
import {
    AffiliateBuyButton,
    AffiliateBuyButtonProps,
} from "./affiliate-buy-button/affiliate-buy-button";
import {
    CheckoutBuyButton,
    CheckoutBuyButtonProps,
} from "./checkout-buy-button/checkout-buy-button";

type BuyButtonProps =
    | ({
          isCheckout: true;
      } & CheckoutBuyButtonProps)
    | ({
          isCheckout?: false;
      } & AffiliateBuyButtonProps);

export const BuyButton = memo(function _BuyButton(props: BuyButtonProps) {
    return props.isCheckout ? <CheckoutBuyButton {...props} /> : <AffiliateBuyButton {...props} />;
});
